<!--eslint-disable-->
<template>
    <el-container>
        <el-main class="main">
            <el-dialog title="Alterar percentuais Mellon (Ex: 0.05)" :visible.sync="dialogPercMellonVisible">
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="pagamentoServicoFileData"
                    size="mini"
                    stripe>
                    <el-table-column
                        prop="fundo"
                        label="Fundo"
                        align="center"
                        width="250">
                        <template slot-scope="scope">
                            <span> {{ scope.row[scope.column.property] }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="percMellon"
                        label="% Mellon"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarPercMellon"></NewEditableColumn>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog title="Template de email para distribuidoras" :visible.sync="dialogEmailDistributorsVisible">
                <el-form :model="emailTemplate">
                    <el-form-item label="Destinatários além do email cadastrado da distribuidora (separados por ;)">
                        <el-input v-model="emailTemplate.recipients"></el-input>
                    </el-form-item>
                    <el-form-item label="Assunto">
                        <el-input v-model="emailTemplate.subject"></el-input>
                    </el-form-item>
                    <el-form-item label="Corpo do email">
                        <el-input type="textarea" v-model="emailTemplate.content"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogEmailDistributorsVisible = false">Cancelar</el-button>
                    <el-button type="primary" @click="updateDistributorsEmailTemplate">Salvar</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Enviar emails de rebate para distribuidoras" :visible.sync="emailToDistributorDialogVisible">
                <span style="font-size: 15px;">
                    Selecione as distribuidoras para as quais enviar email com o arquivo de rebate em anexo:
                </span>
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="sendEmailToDistributorsData"
                    size="mini"
                    stripe>
                    <el-table-column
                        prop="distribuidorChecked"
                        width="35">
                        <template slot="header">
                            <el-checkbox @change="changeAllDistributorsToSendEmailCheckboxes"></el-checkbox>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checkboxStatus"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="distribuidora"
                        label="Distribuidora"
                        align="center"
                        width="250">
                        <template slot-scope="scope">
                            <span> {{ scope.row[scope.column.property] }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        label="Email"
                        align="center"
                        width="350">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarEmailDistribuidora"></NewEditableColumn>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEmailToDistributorDialog">Cancelar</el-button>
                    <el-button type="primary" @click="sendEmailToDistributorsConfirm">Enviar</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Download arquivo de rebate distribuidoras" :visible.sync="downloadDistributorDialogVisible">
                <span style="font-size: 15px;">
                    Selecione as distribuidoras para as quais fazer download do arquivo de rebate:
                </span>
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="downloadFileDistributorsData"
                    size="mini"
                    stripe>
                    <el-table-column
                        prop="distribuidorChecked"
                        width="35">
                        <template slot="header">
                            <el-checkbox @change="changeAllDistributorsToDownloadFileCheckboxes"></el-checkbox>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checkboxStatus"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="distribuidora"
                        label="Distribuidora"
                        align="center"
                        width="250">
                        <template slot-scope="scope">
                            <span> {{ scope.row[scope.column.property] }} </span>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeDownloadFileDistributorDialog">Cancelar</el-button>
                    <el-button type="primary" @click="exportDistribuidoras">Download</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Editar cadastro distribuidoras" :visible.sync="listaDistribuidorasDialogVisible">
                <el-collapse>
                    <el-collapse-item title="Adicionar nova linha">
                        <el-form :model="newDistribuidora">
                            <el-form-item label="Nome">
                                <span>O nome da distribuidora deve ser escrito ao igual a como vem na Mellon</span>
                                <el-input v-model="newDistribuidora.nome"></el-input>
                            </el-form-item>
                            <el-form-item label="CNPJ">
                                <el-input v-model="newDistribuidora.cnpj"></el-input>
                            </el-form-item>
                            <el-button @click="addDistribuidora" type="primary" style="margin-left: 10px">Adicionar</el-button>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="listaDistribuidoras"
                    size="mini"
                    stripe>
                    <el-table-column
                        sortable
                        prop="nome"
                        label="Nome"
                        align="center">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="editDistribuidoras"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="cnpj"
                        label="CNPJ"
                        align="center">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="editDistribuidoras"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="delete"
                        align="center"
                        width="50"> 
                        <template slot-scope="scope">
                            <div class="header-details">
                                <span @click="removerDistribuidora(scope)"><i class="el-icon-delete"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEditDistribuidoraDialog">Cancelar</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Editar lista de reversões" :visible.sync="listaReversaoDialogVisible">
                <el-collapse>
                    <el-collapse-item title="Adicionar nova linha">
                        <el-form :model="newReversao">
                            <el-form-item label="Nome">
                                <el-input v-model="newReversao.nome"></el-input>
                            </el-form-item>
                            <el-form-item label="CNPJ">
                                <el-input v-model="newReversao.cnpj"></el-input>
                            </el-form-item>
                            <el-button @click="addReversao" type="primary" style="margin-left: 10px">Adicionar</el-button>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="listaReversao"
                    size="mini"
                    stripe>
                    <el-table-column
                        sortable
                        prop="nome"
                        label="Nome do cliente"
                        align="center">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="editReversao"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="cnpj"
                        label="CNPJ"
                        align="center">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="editReversao"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="delete"
                        align="center"
                        width="50"> 
                        <template slot-scope="scope">
                            <div class="header-details">
                                <span @click="removerReversao(scope)"><i class="el-icon-delete"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEditReversaoDialog">Cancelar</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Editar lista de fundos sem contrato" :visible.sync="fundosSemContratoDialogVisible">
                <el-collapse>
                    <el-collapse-item title="Adicionar nova linha">
                        <el-form :model="newFundoSemContrato">
                            <el-form-item label="Nome">
                                <el-input v-model="newFundoSemContrato.nome"></el-input>
                            </el-form-item>
                            <el-button @click="addFundoSemContrato" type="primary" style="margin-left: 10px">Adicionar</el-button>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="fundosSemContrato"
                    size="mini"
                    stripe>
                    <el-table-column
                        sortable
                        prop="nome"
                        label="Nome do cliente"
                        align="center"
                        width="250">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="editFundosSemContrato"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="delete"
                        align="center"
                        width="50"> 
                        <template slot-scope="scope">
                            <div class="header-details">
                                <span @click="removerFundosSemContrato(scope)"><i class="el-icon-delete"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEditFundosSemContratoDialog">Cancelar</el-button>
                </span>
            </el-dialog>
            <el-dialog title="Editar lista de fundos que não devem aparecer na boletagem" :visible.sync="fundosNaoDevemAparecerNaBoletagemDialogVisible">
                <el-collapse>
                    <el-collapse-item title="Adicionar nova linha">
                        <el-form :model="newFundoNaoDevemAparecerNaBoletagem">
                            <el-form-item label="Nome">
                                <el-input v-model="newFundoNaoDevemAparecerNaBoletagem.nome"></el-input>
                            </el-form-item>
                            <el-button @click="addFundosNaoDevemAparecerNaBoletagem" type="primary" style="margin-left: 10px">Adicionar</el-button>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
                <el-table
                    style="margin-top: 20px; width: 100%;"
                    :data="fundosNaoDevemAparecerNaBoletagem"
                    size="mini"
                    stripe>
                    <el-table-column
                        sortable
                        prop="nome"
                        label="Nome do cliente"
                        align="center"
                        width="250">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="editFundosNaoDevemAparecerNaBoletagem"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="delete"
                        align="center"
                        width="50"> 
                        <template slot-scope="scope">
                            <div class="header-details">
                                <span @click="removerFundosNaoDevemAparecerNaBoletagem(scope)"><i class="el-icon-delete"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEditFundosNaoDevemAparecerNaBoletagemDialog">Cancelar</el-button>
                </span>
            </el-dialog>
            <el-popover
                placement="bottom"
                trigger="click">
                <el-upload
                    class="upload-element"
                    action=""
                    :http-request="handleUploadAdministradora"
                    :on-remove="handleRemoveAdministradora"
                    :limit="1"
                    :on-exceed="multipleFilesAdministradoraUploaded"
                    :file-list="fileListAdministradora">
                    <el-button size="mini" type="primary">Upload arquivo da Administradora .txt</el-button>
                </el-upload>
                <el-upload
                    class="upload-element"
                    action=""
                    :http-request="handleUploadPagamentoServico"
                    :on-remove="handleRemovePagamentoServico"
                    :limit="1"
                    :on-exceed="multipleFilesPagamentoServicoUploaded">
                    <el-button size="mini" type="primary">Upload arquivo Pagamento de Serviço .csv</el-button>
                </el-upload>
                <el-upload
                    class="upload-element"
                    action=""
                    :http-request="handleUploadPerformit"
                    :on-remove="handleRemovePerformit"
                    :limit="1"
                    :on-exceed="multipleFilesPerformitUploaded">
                    <el-button size="mini" type="primary">Upload arquivo do Performit .txt</el-button>
                </el-upload>
                <el-button type="primary" slot="reference" size="small">Upload de arquivos</el-button>
            </el-popover>
            <el-popover
                placement="bottom"
                trigger="click">
                <el-row style="margin-bottom: 10px;">
                    <el-button @click="showEditFundosNaoDevemAparecerNaBoletagemDialog" type="primary" size="mini">
                        <FSIcon name="edit"></FSIcon>Fundos que não devem aparecer na boletagem
                    </el-button>
                </el-row>
                <el-row style="margin-bottom: 10px;">
                    <el-button @click="showEditReversaoDialog" type="primary" size="mini">
                        <FSIcon name="edit"></FSIcon>Reversao
                    </el-button>
                    <el-button @click="showEditFundosSemContratoDialog" type="primary" size="mini">
                        <FSIcon name="edit"></FSIcon>Fundos sem contrato
                    </el-button>
                    <el-button @click="showEditDistribuidoraDialog" type="primary" size="mini">
                        <FSIcon name="edit"></FSIcon>CNPJ Favorecidos
                    </el-button>
                </el-row>
                <el-row style="margin-bottom: 10px;">
                    <el-button @click="showPercMellonDialog" type="primary" size="mini">
                        <FSIcon name="edit"></FSIcon>Percentuais Mellon
                    </el-button>
                    <el-button @click="showEmailToDistributorDialog" type="primary" size="mini">
                        <FSIcon name="mail"></FSIcon>Distribuidoras
                    </el-button>
                    <el-button @click="showDialogEmailDistributors" type="primary" size="mini">
                        <FSIcon name="edit"></FSIcon>Email template
                    </el-button>
                </el-row>
                <el-button type="primary" slot="reference" size="small" style="margin-left: 10px;">Operações</el-button>
            </el-popover>
            <el-popover
                placement="bottom"
                trigger="click">
                <el-row style="margin-bottom: 10px;">
                    <el-button @click="showDownloadFileDistributorDialog" type="primary" size="mini">Distribuidores</el-button>
                    <el-button @click="exportTableData" type="primary" size="mini">Memória de Cálculo</el-button>
                </el-row>
                <el-row>
                    <el-button @click="exportMellon" type="primary" size="mini">Mellon</el-button>
                    <el-button @click="exportIcatu" type="primary" size="mini">Icatu</el-button>
                    <el-button @click="exportPrev" type="primary" size="mini">Prev</el-button>
                    <el-button @click="exportXPeRico" type="primary" size="mini">XP e Rico</el-button>
                </el-row>
                <el-button type="primary" slot="reference" size="small" style="margin-left: 10px;">Downloads</el-button>
            </el-popover>
            <el-button type="primary" class="el-icon-document" style="float: right; margin-right: 20px" size="small"
                @click="openDocumentation()">
                Documentação
            </el-button>
            <template v-if="showMultipleFilesAdministradoraUploaded">
                <el-alert
                    title="Apenas um arquivo da administradora pode ser usado por vez, para usar um novo arquivo primeiro exclua o anterior."
                    type="error">
                </el-alert>
            </template>
            <template v-if="showMultipleFilesPerformitUploaded">
                <el-alert
                    title="Apenas um arquivo do performit pode ser usado por vez, para usar um novo arquivo primeiro exclua o anterior."
                    type="error">
                </el-alert>
            </template>
            <template v-if="showMultipleFilesPagamentoServicoUploaded">
                <el-alert
                    title="Apenas um arquivo de Pagamento de Serviço pode ser usado por vez, para usar um novo arquivo primeiro exclua o anterior."
                    type="error">
                </el-alert>
            </template>
            <div id="table-div">
                <el-table
                    v-loading="loadingTable"
                    :data="displayData"
                    :max-height="heightClientsTable"
                    :row-class-name="tableRowClassSet"
                    size="mini"
                    border
                    @sort-change="sortTableCollumn"
                    @filter-change="filterTable">
                    <el-table-column
                        type="index"
                        :index="tableIndexMethod"
                        align="center"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        prop="distribuidora"
                        column-key="distribuidora"
                        label="Distribuidora (Mellon)"
                        sortable="custom"
                        align="center"
                        width="200"
                        :filters="distribuidoraFilters"
                        :filter-method="filterHandler">
                        <template slot-scope="scope">
                            <span> {{ scope.row[scope.column.property] }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="distribuidoraPerformit"
                        column-key="distribuidoraPerformit"
                        label="Distribuidora (Performit)"
                        sortable="custom"
                        align="center"
                        width="200"
                        :filters="distribuidoraPerformitFilters"
                        :filter-method="filterHandler">
                        <template slot-scope="scope">
                            <span v-if='scope.row["admPerformit"] != undefined'> {{ scope.row[scope.column.property] }} </span>
                            <template v-if='scope.row["admPerformit"] == undefined'>
                                <el-select v-model="scope.row[scope.column.property]" placeholder="Selecione"
                                    @change="newPerformitDistributorSelected(scope.row)">
                                    <el-option
                                        v-for="item in optionsDistributorPerformit"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="descricaoDoFundo"
                        column-key="descricaoDoFundo"
                        label="Descrição do Fundo"
                        sortable="custom"
                        align="center"
                        width="200"
                        :filters="descricaoDoFundoFilters"
                        :filter-method="filterHandler">
                        <template slot-scope="scope">
                            <span> {{ scope.row[scope.column.property] }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="nomeDoCliente"
                        column-key="nomeDoCliente"
                        label="Nome do cliente"
                        sortable="custom"
                        align="center"
                        width="200">
                        <template slot-scope="scope">
                            <span> {{ scope.row[scope.column.property] }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="taxaDeAdministracao"
                        column-key="taxaDeAdministracao"
                        label="Taxa de administração"
                        sortable="custom"
                        align="center"
                        width="165">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="taxaDePerformanceApropriada"
                        column-key="taxaDePerformanceApropriada"
                        label="Taxa de performance apropriada"
                        sortable="custom"
                        align="center"
                        width="135">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="taxaDePerformanceSobreResgate"
                        column-key="taxaDePerformanceSobreResgate"
                        label="Taxa de performance sobre resgate"
                        sortable="custom"
                        align="center"
                        width="135">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="taxaDeGestao"
                        column-key="taxaDeGestao"
                        label="Taxa de gestão"
                        sortable="custom"
                        align="center"
                        width="135">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="calcPerf"
                        column-key="calcPerf"
                        label="Cálculo Performance (R$)"
                        sortable="custom"
                        align="center"
                        width="140">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="calcPerfApropriada"
                        column-key="calcPerfApropriada"
                        label="Cálculo Performance Apropriada (R$)"
                        sortable="custom"
                        align="center"
                        width="140">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="calcPerfSobreResgate"
                        column-key="calcPerfSobreResgate"
                        label="Cálculo Performance Sobre Resgate (R$)"
                        sortable="custom"
                        align="center"
                        width="140">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="calcAdm"
                        column-key="calcAdm"
                        label="Cálculo Adm (R$)"
                        sortable="custom"
                        align="center"
                        width="90"
                        fixed="right">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="admPerformit"
                        column-key="admPerformit"
                        label="Adm performit (R$)"
                        sortable="custom"
                        align="center"
                        width="100"
                        fixed="right">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="admDiferenca"
                        column-key="admDiferenca"
                        label="Adm diferença (R$)"
                        sortable="custom"
                        align="center"
                        width="100"
                        fixed="right">
                        <template slot-scope="scope">
                            <span> {{ formatValue(scope.row[scope.column.property]) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="valorAcatadoAdm"
                        column-key="valorAcatadoAdm"
                        label="Valor Acatado Adm (R$)"
                        align="center"
                        width="100"
                        fixed="right">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="valorAcatadoAdmChanged"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="valorAcatadoPerf"
                        column-key="valorAcatadoPerf"
                        label="Valor Acatado Perf (R$)"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="valorAcatadoPerfChanged"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="valorAcatadoPerfApropriada"
                        column-key="valorAcatadoPerfApropriada"
                        label="Valor Acatado Perf Apropriada (R$)"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="valorAcatadoPerfChanged"></NewEditableColumn>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="valorAcatadoPerfSobreResgate"
                        column-key="valorAcatadoPerfSobreResgate"
                        label="Valor Acatado Perf Sobre Resgate (R$)"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <NewEditableColumn :scope="scope" v-on:saveToFirestore="valorAcatadoPerfChanged"></NewEditableColumn>
                        </template>
                    </el-table-column>
                </el-table>
                <span style="color:gray; font-size:15px">Tolerância de erro de {{ this.diferenceErrorTolerance }}. Diferenças até esse valor serão exibidas como 0.</span>
                <el-pagination
                    id="pagination"
                    background
                    :page-size="linesInTablePage"
                    :pager-count="10"
                    layout="prev, pager, next"
                    :total="totalLinesInTable"
                    @current-change="handleCurrentPageChange">
                </el-pagination>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import format from 'xml-formatter'
import regex from '@/services/regex'
import deParaNomeDoClienteMellonPerformit from '@/services/deParaRebate' // Extrair do código para banco e criar uma interface para editar
import deParaFundoNomeCNPJ from '@/services/deParaFundoNomeCNPJ' // Extrair do código para banco e criar uma interface para editar

const db = fb.db

const FUNDO_70_XP = 'LEBLON 70 XP SEGUROS PREV FIM'
const FUNDO_100_XP = 'LEBLON 100 XP SEGUROS PREV FI'
const FUNDO_100_ICATU = 'LEBLON 100 ICATU PREV FIM'

const gestorName = 'LEBLON EQUITIES GESTAO DE RECURSOS LTDA'
const gestorCNPJ = '10.240.925/0001-63'
const icatuName = 'ICATU CONSULTORIA DE INVESTIMENTOS LTDA'
const icatuCNPJ = '22.315.180/0001-33'
const xpName = 'XP VIDA e PREVIDÊNCIA SA'
const xpCNPJ = '29.408.732/0001-05'

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export default {
    data() {
        return {
            showUploadButtons: true,
            showDownloadButtons: true,
            loadingTable: false,
            tableData: [],
            performitData: {},
            currentFilters: {
                distribuidora: [],
                distribuidoraPerformit: [],
                descricaoDoFundo: [],
                nomeDoCliente: [],
                taxaDePerformanceApropriada: [],
                taxaDePerformanceSobreResgate: [],
                taxaDeAdministracao: [],
                taxaDeGestao: []
            },
            rules: [],
            fileListAdministradora: [],
            showMultipleFilesAdministradoraUploaded: false,
            showMultipleFilesPerformitUploaded: false,
            showMultipleFilesPagamentoServicoUploaded: false,
            tablePage: 1,
            linesInTablePage: 100,
            diferenceErrorTolerance: 0.01,
            optionsDistributorPerformit: [],
            dialogEmailDistributorsVisible: false,
            emailTemplate: {
                recipients: '',
                subject: '',
                content: '',
                firebaseDocId: ''
            },
            distributorsEmails: {},
            dialogPercMellonVisible: false,
            emailToDistributorDialogVisible: false,
            sendEmailToDistributorsData: [],
            downloadDistributorDialogVisible: false,
            downloadFileDistributorsData: [],
            pagamentoServicoFileData: [],
            fundosNaoDevemAparecerNaBoletagem: [],
            fundosNaoDevemAparecerNaBoletagemDialogVisible: false,
            newFundoNaoDevemAparecerNaBoletagem: {
                nome: ''
            },
            fundosSemContrato: [],
            fundosSemContratoDialogVisible: false,
            newFundoSemContrato: {
                nome: ''
            },
            listaReversao: [],
            listaReversaoDialogVisible: false,
            newReversao: {
                nome: '',
                cnpj: ''
            },
            listaDistribuidoras: [],
            listaDistribuidorasDialogVisible: false,
            newDistribuidora: {
                nome: '',
                cnpj: ''
            }
        }
    },
    components: {
        NewEditableColumn
    },
    methods: {
        openDocumentation() {
            window.open('https://docs.google.com/document/d/1G6kZ5nTWEsg8G5lxSzAFlzanukNRTJpmWG_dd7SsdHw/edit?usp=sharing', '_blank')
        },
        closePercMellonDialog() {
            this.dialogPercMellonVisible = false
        },
        showPercMellonDialog() {
            this.dialogPercMellonVisible = true
        },
        distribuidoraEReversao(distribuidora) {
            return distribuidora.toUpperCase().includes('REVERSÃO')
        },
        async adicionarDistribuidoraEmListasParaEmailEDownload(distribuidora) {
            if (this.distributorsEmails[distribuidora] == undefined) {
                await db.collection('rebateDistributorsCadastro').add({distribuidora, email: '-'})
                await this.updateDistributorsEmailsObject()
            }
            // console.log(this.sendEmailToDistributorsData, distribuidora)
            if (this.sendEmailToDistributorsData.filter(element => element.distribuidora == distribuidora).length == 0) {
                this.sendEmailToDistributorsData.push({
                    checkboxStatus: false,
                    distribuidora,
                    email: this.distributorsEmails[distribuidora].email
                })
            }
            if (this.downloadFileDistributorsData.filter(element => element.distribuidora == distribuidora).length == 0) {
                this.downloadFileDistributorsData.push({
                    checkboxStatus: false,
                    distribuidora,
                    email: this.distributorsEmails[distribuidora].email
                })
            }
        },
        async newPerformitDistributorSelected(row) {
            this.calcAndSetAdmEPerformance(row)
            let distribuidora = row.distribuidoraPerformit
            this.adicionarDistribuidoraEmListasParaEmailEDownload(distribuidora)
            if(this.distribuidoraEReversao(distribuidora)) {
                this.atualizarListaDeReversao(row.nomeDoCliente)
            }
            
        },
        alterarPercMellon(value, scope) {
            // Para cada linha na tabela que for do fundo cujo percentual Mellon foi alterado recalcular adm e performance.
            this.tableData = this.tableData.map(row => {
                if (row.descricaoDoFundo == scope.row.fundo) {
                    this.calcAndSetAdmEPerformance(row)
                }
                return row
            })
            
        },
        fixTyposInClientName(clientName0) {
            let clientName1 = clientName0.replace('  ', ' ') // ENERGISAPREV vem com dois espaços entre ENERGISAPREV e FUNDACAO na Mellon
            let clientName2 = clientName1.trim() // TERRAZUL vem com espaço no final do nome na Mellon
            return clientName2
        },
        formatValue(valueAsNumberOrString) {
            if (valueAsNumberOrString === undefined) {
                return undefined
            }
            let valueAsString = typeof valueAsNumberOrString === 'number' ? valueAsNumberOrString.toFixed(2) : this.formatedValueToFloat(valueAsNumberOrString).toFixed(2)
            return valueAsString ? valueAsString.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".") : valueAsString
        },
        formatedValueToFloat(formatedValue) {
            if (typeof formatedValue == 'string') {
                return parseFloat(formatedValue.replace(/\./g, '').replace(',', '.'))
            }
        },
        async updateDistributorsEmailsObject() {
            let distributors = await db.collection('rebateDistributorsCadastro').get()
            distributors.forEach(doc => {
                this.distributorsEmails[doc.data().distribuidora] = {
                    docId: doc.id,
                    email: doc.data().email
                }
            })
        },
        async alterarEmailDistribuidora(value, scope) {
            try {
                let distribuidora = scope.row.distribuidora
                let docId = this.distributorsEmails[distribuidora].docId
                await db.collection('rebateDistributorsCadastro').doc(docId).set({distribuidora, email: value})
                await this.updateDistributorsEmailsObject()
            } catch(err) {
                console.log(err)
                this.$root.$emit('showError', "Erro. Entre em contato com o administrador do site.", 'error')
            }
        },
        valorAcatadoAdmChanged(value, scope) {},
        valorAcatadoPerfChanged(value, scope) {},
        generatePerformitDataKey(cliente, fundo) {
            let treatedClient = cliente != undefined ? cliente : ''
            if (deParaNomeDoClienteMellonPerformit[cliente] != undefined) {
                treatedClient = deParaNomeDoClienteMellonPerformit[cliente]
            }
            return `${treatedClient.toUpperCase()} /// ${(fundo != undefined ? fundo : '').toUpperCase()}`
        },
        calcAdmForRow(fundo, distribuidora, taxaAdm) {
            let rulesForRow = this.rules[distribuidora]
            if (!rulesForRow) {
                // Não há regras para a distribuidora, deve ser logado um erro para o usuário
                console.log(`Não foram encontradas regras para a distribuidora ${distribuidora}. Tente adicioná-las na página de regras de Rebate.`)
                this.$root.$emit('showError', `Não foram encontradas regras para a distribuidora ${distribuidora}. Tente adicioná-las na página de regras de Rebate.`, 'error')
            }
            let isLiquido = rulesForRow.liquidoBruto == 'liquido' ? true : false
            let percAdministradorAsArray = this.pagamentoServicoFileData.filter(row => row.fundo == fundo)
            if (percAdministradorAsArray.length == 0) {
                this.pagamentoServicoFileData.push({
                    fundo,
                    percMellon: 0
                })
                percAdministradorAsArray = [{
                    fundo,
                    percMellon: 0
                }]
            }
            let percAdministrador = percAdministradorAsArray[0].percMellon
            let percDistribuidora = parseFloat(rulesForRow.percAdm)/100
            return isLiquido ? taxaAdm * (1 - percAdministrador) * percDistribuidora : taxaAdm * percDistribuidora
        },
        calcPerfForRow(distribuidora, taxaDePerformanceApropriada, taxaDePerformanceSobreResgate) {
            let rulesForRow = this.rules[distribuidora]
            if (!rulesForRow) {
                // Não há regras para a distribuidora, deve ser logado um erro para o usuário
                this.$root.$emit('showError', `Não foram encontradas regras para a distribuidora ${distribuidora}. Tente adicioná-las na página de regras de Rebate.`, 'error')
                console.log(`Não foram encontradas regras para a distribuidora ${distribuidora}. Tente adicioná-las na página de regras de Rebate.`)
            }
            let percDistribuidora = parseFloat(rulesForRow.percPerf)/100
            let dateObj = new Date()
            let currentMonth = dateObj.getMonth() + 1
            let taxaDePerformance = currentMonth == 1 || currentMonth == 7
                ? taxaDePerformanceSobreResgate + taxaDePerformanceApropriada
                : taxaDePerformanceSobreResgate
            return taxaDePerformance * percDistribuidora
        },
        tableRowClassSet({rowIndex, row}) {
            if (row["admPerformit"] === undefined) {
                return 'not-found-row'
            }
            if (Math.abs(row["admDiferenca"]) === 0) {
                return 'success-row'
            }
            return 'warning-row'
        },
        handleRemoveAdministradora(file, fileListAdministradora) {
            this.tableData = []
            this.sendEmailToDistributorsData = []
            this.downloadFileDistributorsData = []
        },
        handleRemovePerformit(file, _) {
            // TODO Zerar colunas de valores do Performit, Cálculo de Adm e Diferença Adm
        },
        handleRemovePagamentoServico(file, _) {
            // TODO Implementar
        },
        async makeTableDataFromAdministratorFile(rawData) {
            rawData.sort((line1, line2) => { // Ordena primeiro por nome do cliente e em segundo nível por descrição do fundo
                if (line1[5] < line2[5]) {
                    return -1
                }
                if (line1[5] > line2[5]) {
                    return 1
                }
                if (line1[3] < line2[3]) {
                    return -1
                }
                return 1
            })
            rawData.map(line => {
                let lastLine = this.tableData[this.tableData.length - 1] ? this.tableData[this.tableData.length - 1] : {}
                let lastLinePerformitDataKey = this.generatePerformitDataKey(lastLine.nomeDoCliente, lastLine.descricaoDoFundo)
                let currentLinePerformitDataKey = this.generatePerformitDataKey(this.fixTyposInClientName(line[5]), line[3])
                if (lastLinePerformitDataKey == currentLinePerformitDataKey) {
                    let previous = this.tableData[this.tableData.length - 1].taxaDeAdministracao
                    this.tableData[this.tableData.length - 1].taxaDePerformanceApropriada += parseFloat(line[6])
                    this.tableData[this.tableData.length - 1].taxaDePerformanceSobreResgate += parseFloat(line[7])
                    this.tableData[this.tableData.length - 1].taxaDeAdministracao += parseFloat(line[8])
                    this.tableData[this.tableData.length - 1].taxaDeGestao += parseFloat(line[9])
                } else {
                    this.tableData.push({
                        distribuidora: line[0],
                        descricaoDoFundo: line[3],
                        nomeDoCliente: this.fixTyposInClientName(line[5]),
                        taxaDePerformanceApropriada: parseFloat(line[6]),
                        taxaDePerformanceSobreResgate: parseFloat(line[7]),
                        taxaDeAdministracao: parseFloat(line[8]),
                        taxaDeGestao: parseFloat(line[9])
                    })
                }
                let percAdministradorAsArray = this.pagamentoServicoFileData.filter(row => row.fundo == line[3])
                if (percAdministradorAsArray.length == 0) {
                    this.pagamentoServicoFileData.push({
                        fundo: line[3],
                        percMellon: 0
                    })
                }
            })
        },
        handleUploadAdministradora(file, _) {
            this.loadingTable = true
            let fileReader = new FileReader()
            fileReader.onload = function (fileName, event) {
                let text = event.target.result
                let textParsedLines = text.split("\n")
                let textAsArray = textParsedLines.map((line) => {
                    return line.split("\t")
                })
                let dataWithoutHeader = textAsArray.slice(1, textAsArray.length)
                let dataWithoutHeaderAndWithoutZeros = dataWithoutHeader.filter((line) => {
                    return parseFloat(line[8]) != 0
                })
                this.makeTableDataFromAdministratorFile(dataWithoutHeaderAndWithoutZeros)
                this.loadingTable = false
            }.bind(this, file.file.name)
            fileReader.readAsText(file.file)
        },
        async handleUploadPagamentoServico(file, _) {
            this.loadingTable = true
            let fileReader = new FileReader()
            fileReader.onload = async function (fileName, event) {
                let text = event.target.result
                let textParsedLines = text.split("\n")
                let textAsArray = textParsedLines.map((line) => {
                    return line.split(";").map(str => str.trim())
                })
                let dataWithoutHeader = textAsArray.slice(2, textAsArray.length)
                dataWithoutHeader.map(row => {
                    // Não incluir linhas em que o fundo apareca como undefined
                    if (row[1]) {
                        // Se o fundo já está no array do pagamentoServicoFileData, apagá-lo para atualizar as informações dele.
                        this.pagamentoServicoFileData = this.pagamentoServicoFileData.filter((pagamentoServicoFileDataRow) => pagamentoServicoFileDataRow.fundo !== row[1])
                        this.pagamentoServicoFileData.push({
                            iliquido: row[0],
                            fundo: row[1],
                            codigo: row[2],
                            taxaAdministracao: row[3],
                            administracaoFiduciaria: row[4],
                            servico: row[5],
                            saldoParcial: row[6],
                            saldoGestor: row[7],
                            aprovado: row[8],
                            agendamento: row[9],
                            percMellon: parseFloat(this.formatedValueToFloat(row[4])/this.formatedValueToFloat(row[3]))
                        })
                    }
                })
                this.tableData.forEach(row => this.calcAndSetAdmEPerformance(row))
                this.loadingTable = false
            }.bind(this, file.file.name)
            fileReader.readAsText(file.file)
        },
        async handleUploadPerformit(file, _) {
            this.loadingTable = true
            let fileReader = new FileReader()
            fileReader.onload = async function (fileName, event) {
                let text = event.target.result
                let textParsedLines = text.split("\n")
                let textAsArray = textParsedLines.map((line) => {
                    return line.split("\t")
                })
                let dataWithoutHeader = textAsArray.slice(1, textAsArray.length)
                dataWithoutHeader.map(line => {
                    let performitDataKey = this.generatePerformitDataKey(line[2], line[1])
                    if (this.performitData[performitDataKey] !== undefined) { // Já há uma linha para cotista - fundo, devo somar os valores.
                        let previous = this.performitData[performitDataKey].total
                        this.performitData[performitDataKey].total += parseFloat(line[4] ? line[4].replace('.', '').replace(',', '.') : line[4]) // Milhares vem do Performit separados por '.'. Devemos remover esse ponto.
                    } else { // Ainda não tenho uma linha para cotista - fundo, devo criar uma
                        this.performitData[performitDataKey] = {
                            distribuidora: line[0],
                            fundo: line[1],
                            cliente: this.fixTyposInClientName(line[2] ? line[2] : ''),
                            total: parseFloat(line[4] ? line[4].replace('.', '').replace(',', '.') : line[4]) // Milhares vem do Performit separados por '.'. Devemos remover esse ponto.
                        }
                    }
                })
                let distributorsSet = new Set()
                let performitReversaoClientes = []
                this.tableData.map(async row => {
                    let perfomitKeyForThisRow = this.generatePerformitDataKey(row["nomeDoCliente"], row["descricaoDoFundo"])
                    let performitDataForThisRow = this.performitData[perfomitKeyForThisRow]
                    if (performitDataForThisRow == undefined) {
                    } else {
                        row["distribuidoraPerformit"] = performitDataForThisRow.distribuidora
                        row["admPerformit"] = performitDataForThisRow.total
                        this.calcAndSetAdmEPerformance(row)

                        if (this.distribuidoraEReversao(row["distribuidoraPerformit"])) {
                            performitReversaoClientes.push(row["nomeDoCliente"])
                            if (!distributorsSet.has(row["distribuidoraPerformit"])) {
                                distributorsSet.add(row["distribuidoraPerformit"])
                            }
                        } else {
                            if (!distributorsSet.has(row["distribuidora"])) {
                                distributorsSet.add(row["distribuidora"])
                            }
                        }
                    }
                })
                let distributorSetAsArray = [...distributorsSet]
                await Promise.all(distributorSetAsArray.map(distribuidora => {
                    this.adicionarDistribuidoraEmListasParaEmailEDownload(distribuidora)
                }))
                await Promise.all(performitReversaoClientes.map(cliente => {
                    this.atualizarListaDeReversao(cliente)
                }))
                this.loadingTable = false
            }.bind(this, file.file.name)
            fileReader.readAsText(file.file, 'ISO-8859-1')
        },
        async atualizarListaDeReversao (cliente) {
            if(this.listaReversao.map(reversaoCase => reversaoCase.nome).includes(cliente)) {
            } else {
                console.log(`Não - ${cliente}`)
                await db.collection("rebateExcecoesCadastro").doc("listaReversao").update({
                    data: firebase.firestore.FieldValue.arrayUnion({
                        nome: cliente,
                        cnpj: '-'
                    })
                })
            }
        },
        multipleFilesAdministradoraUploaded() {
            this.showMultipleFilesAdministradoraUploaded = true
        },
        multipleFilesPerformitUploaded() {
            this.showMultipleFilesPerformitUploaded = true
        },
        multipleFilesPagamentoServicoUploaded() {
            this.showMultipleFilesPagamentoServicoUploaded = true
        },
        filterTable(filters) {
            let columnsToFilter = Object.keys(filters)
            columnsToFilter.map((columnToFilter) => {
                this.currentFilters[columnsToFilter] = filters[columnToFilter]
            })
        },
        filterHandler(value, row, column) {
            return true
        },
        getFilterPossibleValues(prop, blank = ['', '-']) {
            let list = []
            let filters = []
            this.tableData.forEach(row => {
                list.push(row[prop])
            })
            list = [...new Set(list)].sort()
            list.forEach(each => {
                filters.push({ text: each === blank[0] ? blank[1] : each, value: each })
            })
            if (filters.length > 500) {
                return []
            }
            return filters
        },
        handleCurrentPageChange(currentPage) {
            this.tablePage = currentPage
        },
        tableIndexMethod(index) {
            return (this.tablePage - 1) * this.linesInTablePage + index
        },
        sortTableCollumn({ column, prop, order }) {
            this.tableData = this.tableData.sort((line1, line2) => {
                let firstElement = line1[prop] === undefined ? -1 * Math.pow(10, 6) : line1[prop]
                let secondElement = line2[prop] === undefined ? -1 * Math.pow(10, 6) : line2[prop]
                if (order == "ascending") {
                    return firstElement <= secondElement ? -1 : 1
                } else {
                    return firstElement > secondElement ? -1 : 1
                }
            })
        },
        calcAndSetAdmEPerformance(row) {
            if (row["distribuidoraPerformit"]) {
                row["calcAdm"] = this.calcAdmForRow(row["descricaoDoFundo"], row["distribuidoraPerformit"], parseFloat(row["taxaDeAdministracao"])),
                row["valorAcatadoAdm"] = this.formatValue(row["calcAdm"])

                if (!(row["admPerformit"] === undefined)) {
                    let diferenceWithoutTolerance = row["calcAdm"] - row["admPerformit"]
                    row["admDiferenca"] = Math.abs(diferenceWithoutTolerance) <= this.diferenceErrorTolerance ? 0 : diferenceWithoutTolerance
                }

                row["calcPerf"] = this.calcPerfForRow(row["distribuidoraPerformit"], parseFloat(row["taxaDePerformanceApropriada"]), parseFloat(row["taxaDePerformanceSobreResgate"]))
                row["valorAcatadoPerf"] = this.formatValue(row["calcPerf"])

                row["calcPerfApropriada"] = this.calcPerfForRow(row["distribuidoraPerformit"], parseFloat(row["taxaDePerformanceApropriada"]), 0)
                row["valorAcatadoPerfApropriada"] = this.formatValue(row["calcPerfApropriada"])

                row["calcPerfSobreResgate"] = this.calcPerfForRow(row["distribuidoraPerformit"], 0, parseFloat(row["taxaDePerformanceSobreResgate"]))
                row["valorAcatadoPerfSobreResgate"] = this.formatValue(row["calcPerfSobreResgate"])
            }
        },
        exportTableData() {
            const headers = ["Distribuidora (Mellon)", "Distribuidora (Performit)", "Descrição do Fundo", "Nome do cliente", 
                "Taxa de performance apropriada", "Taxa de performance sobre resgate", "Taxa de administração", "Taxa de gestão", 
                "Cálculo Performance (R$)", "Cálculo Performance Apropriada (R$)", "Cálculo Performance Sobre Resgate (R$)", 
                "Cálculo Adm (R$)", "Adm performit (R$)", "Adm diferença (R$)", "Valor Acatado Adm (R$)", "Valor Acatado Perf (R$)"]
            let csvContent = headers.join(";") + "\n"
                + this.tableData.map((rowAsObj) => {
                    let rowAsArray = [
                        rowAsObj.distribuidora,
                        rowAsObj.distribuidoraPerformit,
                        rowAsObj.descricaoDoFundo,
                        rowAsObj.nomeDoCliente,
                        this.formatValue(rowAsObj.taxaDePerformanceApropriada),
                        this.formatValue(rowAsObj.taxaDePerformanceSobreResgate),
                        this.formatValue(rowAsObj.taxaDeAdministracao),
                        this.formatValue(rowAsObj.taxaDeGestao),
                        this.formatValue(rowAsObj.calcPerf),
                        this.formatValue(rowAsObj.calcPerfApropriada),
                        this.formatValue(rowAsObj.calcPerfSobreResgate),
                        this.formatValue(rowAsObj.calcAdm),
                        this.formatValue(rowAsObj.admPerformit),
                        this.formatValue(rowAsObj.admDiferenca),
                        rowAsObj.valorAcatadoAdm,
                        rowAsObj.valorAcatadoPerf
                    ]
                    return rowAsArray.join(";")
                }).join("\n")
            let encodedUri = encodeURI(csvContent)
            let link = document.createElement("a")
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
            link.setAttribute("download", "rebate_calculo.csv")
            document.body.appendChild(link)
            link.click()
        },
        isCotistaPCO(cotista) {
            let regexCotistaPCO = /[^0-9]+ [0-9]+/
            return regexCotistaPCO.test(cotista)
        },
        async exportXPeRico() {
            await this.exportXPeRicoAdm()
            await this.exportXPeRicoPerfResgate()
            await this.exportXPeRicoPerfApropriada()
        },
        async exportXPeRicoAdm() {
            const headers = []
            let tableDataXPeRico = []
            this.tableData.map(row => {
                if (row.distribuidora == 'XP INVESTIMENTOS CCTVM SA') {
                    let editedRow = Object.assign({}, row)
                    editedRow.distribuidora = 'XPI'
                    let rule = this.rules[row.distribuidoraPerformit]
                    if (rule == undefined) {
                        console.log('RULE UNDEFINED!!', `'${row.distribuidoraPerformit}'`, this.rules)
                    } else {
                        editedRow.percRebate = `${this.rules[row.distribuidoraPerformit].percAdm},00%`
                        tableDataXPeRico.push(editedRow)
                    }
                }
                if (row.distribuidora == 'XP INVESTIMENTOS CCTVM SA FILIAL RICO') {
                    let editedRow = Object.assign({}, row)
                    editedRow.distribuidora = 'RICO'
                    let rule = this.rules[row.distribuidoraPerformit]
                    if (rule == undefined) {
                        console.log('RULE UNDEFINED!!', `'${row.distribuidoraPerformit}'`, this.rules)
                    } else {
                        editedRow.percRebate = `${this.rules[row.distribuidoraPerformit].percAdm},00%`
                        tableDataXPeRico.push(editedRow)
                    }
                }
            })
            let dateObj = new Date()
            dateObj.setDate(dateObj.getDate()-1)
            let formateddateObj = `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
            let csvContent = tableDataXPeRico.map((rowAsObj) => {
                let rowAsArray = [
                    formateddateObj, // Data (Ex: 30/06/2020)
                    rowAsObj.descricaoDoFundo, // Nome do Fundo
                    'BNY Mellon Serviços Financeiros DTVM S.A.', // Administrador
                    deParaFundoNomeCNPJ[rowAsObj.descricaoDoFundo], // CNPJ Fundo
                    rowAsObj.distribuidora, // Distribuidor
                    this.isCotistaPCO(rowAsObj.nomeDoCliente) ? 'S' : 'N', // Cotista PCO
                    rowAsObj.nomeDoCliente, // Nome do Cotista	
                    `R$ ${this.formatValue(rowAsObj.taxaDeAdministracao)}`, // R$ Tx Adm
                    rowAsObj.percRebate, // % Rebate	
                    `R$ ${this.formatValue(rowAsObj.valorAcatadoAdm)}` // Rebate Devido
                ]
                return rowAsArray.join(";")
            }).join("\n")
            let encodedUri = encodeURI(csvContent)
            let link = document.createElement("a")
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
            link.setAttribute("download", "xp_rebate_adm.csv")
            document.body.appendChild(link)
            link.click()
        },
        async exportXPeRicoPerfResgate() {
            const headers = []
            let tableDataXPeRico = []
            this.tableData.map(row => {
                if (row.distribuidora == 'XP INVESTIMENTOS CCTVM SA') {
                    let editedRow = Object.assign({}, row)
                    editedRow.distribuidora = 'XPI'
                    let rule = this.rules[row.distribuidoraPerformit]
                    if (rule == undefined) {
                        console.log('RULE UNDEFINED!!', `'${row.distribuidoraPerformit}'`, this.rules)
                    } else {
                        editedRow.percRebate = `${this.rules[row.distribuidoraPerformit].percPerf},00%`
                        tableDataXPeRico.push(editedRow)
                    }
                }
                if (row.distribuidora == 'XP INVESTIMENTOS CCTVM SA FILIAL RICO') {
                    let editedRow = Object.assign({}, row)
                    editedRow.distribuidora = 'RICO'
                    let rule = this.rules[row.distribuidoraPerformit]
                    if (rule == undefined) {
                        console.log('RULE UNDEFINED!!', `'${row.distribuidoraPerformit}'`, this.rules)
                    } else {
                        editedRow.percRebate = `${this.rules[row.distribuidoraPerformit].percPerf},00%`
                        tableDataXPeRico.push(editedRow)
                    }
                }
            })
            let dateObj = new Date()
            dateObj.setDate(dateObj.getDate()-1)
            let formateddateObj = `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
            let csvContent = tableDataXPeRico.map((rowAsObj) => {
                    let rowAsArray = [
                        formateddateObj, // Data (Ex: 30/06/2020)
                        rowAsObj.descricaoDoFundo, // Nome do Fundo
                        'BNY Mellon Serviços Financeiros DTVM S.A.', // Administrador
                        deParaFundoNomeCNPJ[rowAsObj.descricaoDoFundo], // CNPJ Fundo
                        rowAsObj.distribuidora, // Distribuidor
                        this.isCotistaPCO(rowAsObj.nomeDoCliente) ? 'S' : 'N', // Cotista PCO
                        rowAsObj.nomeDoCliente, // Nome do Cotista	
                        `R$ ${this.formatValue(rowAsObj.taxaDePerformanceSobreResgate)}`, // R$ Pfee sobre Resgate
                        rowAsObj.percRebate, // % Rebate	
                        `R$ ${this.formatValue(rowAsObj.valorAcatadoPerfSobreResgate)}` // Valor do Rebate
                    ]
                    return rowAsArray.join(";")
                }).join("\n")
            let encodedUri = encodeURI(csvContent)
            let link = document.createElement("a")
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
            link.setAttribute("download", "xp_rebate_perf_resg.csv")
            document.body.appendChild(link)
            link.click()
        },
        async exportXPeRicoPerfApropriada() {
            const headers = []
            let tableDataXPeRico = []
            this.tableData.map(row => {
                if (row.distribuidora == 'XP INVESTIMENTOS CCTVM SA') {
                    let editedRow = Object.assign({}, row)
                    editedRow.distribuidora = 'XPI'
                    let rule = this.rules[row.distribuidoraPerformit]
                    if (rule == undefined) {
                        console.log('RULE UNDEFINED!!', `'${row.distribuidoraPerformit}'`, this.rules)
                    } else {
                        editedRow.percRebate = `${this.rules[row.distribuidoraPerformit].percPerf},00%`
                        tableDataXPeRico.push(editedRow)
                    }
                }
                if (row.distribuidora == 'XP INVESTIMENTOS CCTVM SA FILIAL RICO') {
                    let editedRow = Object.assign({}, row)
                    editedRow.distribuidora = 'RICO'
                    let rule = this.rules[row.distribuidoraPerformit]
                    if (rule == undefined) {
                        console.log('RULE UNDEFINED!!', `'${row.distribuidoraPerformit}'`, this.rules)
                    } else {
                        editedRow.percRebate = `${this.rules[row.distribuidoraPerformit].percPerf},00%`
                        tableDataXPeRico.push(editedRow)
                    }
                }
            })
            let dateObj = new Date()
            dateObj.setDate(dateObj.getDate()-1)
            let formateddateObj = `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
            let csvContent = tableDataXPeRico.map((rowAsObj) => {
                    let rowAsArray = [
                        formateddateObj, // Data (Ex: 30/06/2020)
                        rowAsObj.descricaoDoFundo, // Nome do Fundo
                        'BNY Mellon Serviços Financeiros DTVM S.A.', // Administrador
                        deParaFundoNomeCNPJ[rowAsObj.descricaoDoFundo], // CNPJ Fundo
                        rowAsObj.distribuidora, // Distribuidor
                        this.isCotistaPCO(rowAsObj.nomeDoCliente) ? 'S' : 'N', // Cotista PCO
                        rowAsObj.nomeDoCliente, // Nome do Cotista	
                        `R$ ${this.formatValue(rowAsObj.taxaDePerformanceApropriada)}`, // $ Pfee
                        rowAsObj.percRebate, // % Rebate	
                        `R$ ${this.formatValue(rowAsObj.valorAcatadoPerfApropriada)}` // Rebate Devido
                    ]
                    return rowAsArray.join(";")
                }).join("\n")
            let encodedUri = encodeURI(csvContent)
            let link = document.createElement("a")
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
            link.setAttribute("download", "xp_rebate_perf_aprop.csv")
            document.body.appendChild(link)
            link.click()
        },
        createDataToPrevFund(fundName) {
            // Pegar informações do fundo na tabela principal 
            let fundRowInTableArray = this.tableData.filter((row) => row.descricaoDoFundo.toUpperCase().includes(fundName.toUpperCase()))
            if (fundRowInTableArray.length == 0) {
                let err = `Fundo ${fundName} não encontrado nos dados da administradora.`
                console.log(err)
                this.$root.$emit('showError', err, 'error')
                return {}
            }
            if (fundRowInTableArray.length > 1) {
                console.log(`Mais de uma linha encontrada para o fundo de previdência ${fundName} no arquivo da arministradora.
                    Apenas a primeira linha está sendo usada para montar a planilha de prev.`)
            }
            let fundRowInTable = fundRowInTableArray[0]

            // Pegar informações do fundo no arquivo de pagamento de serviço
            let fundRowInPagServArray = this.pagamentoServicoFileData.filter((row) => row.fundo.toUpperCase().includes(fundName.toUpperCase()))
            if (fundRowInPagServArray.length == 0) {
                let err = `Fundo ${fundName} não encontrado no arquivo de Pagamento de Serviço.`
                console.log(err)
                this.$root.$emit('showError', err, 'error')
                return {}
            }
            if (fundRowInPagServArray.length > 1) {
                console.log(`Mais de uma linha encontrada para o fundo de previdência ${fundName} no arquivo de Pagamento de Serviço.
                    Apenas a primeira linha está sendo usada para montar a planilha de prev.`)
            }
            let fundRowInPagServ = fundRowInPagServArray[0]

            // Pegar regra para o fundo no arquivo de pagamento de serviço
            let maybeFundRule = this.rules[fundName]
            if (!maybeFundRule) {
                let err = `Fundo ${fundName} não encontrado na página de regras de rebate.`
                console.log(err)
                this.$root.$emit('showError', err, 'error')
                return {}
            }
            let fundRule = maybeFundRule

            let admTotal = this.formatedValueToFloat(fundRowInTable.taxaDeAdministracao)
            let dateObj = new Date()
            let currentMonth = dateObj.getMonth() + 1
            let perfTotal = currentMonth == 6 || currentMonth == 12
                ? fundRowInTable.taxaDePerformanceSobreResgate + fundRowInTable.taxaDePerformanceApropriada
                : fundRowInTable.taxaDePerformanceSobreResgate
            let admMellon = this.formatedValueToFloat(fundRowInPagServ.administracaoFiduciaria)
            let admSeguradora = fundRule.liquidoBruto == 'liquido' ? (admTotal - admMellon) * fundRule.percAdm/100 : admTotal * fundRule.percAdm/100
            let perfSeguradora = perfTotal * fundRule.percPerf/100
            let admLeblon = admTotal - admMellon - admSeguradora
            let perfLeblon = perfTotal - perfSeguradora

            return {
                'Taxa de adm total': this.formatValue(admTotal),
                'Taxa de perf total': this.formatValue(perfTotal),
                'Taxa adm Mellon': this.formatValue(admMellon),
                'Valor adm para Leblon e XP/Icatu': this.formatValue(admTotal - admMellon),
                'Valor XP/Icatu adm': this.formatValue(admSeguradora),
                'Valor XP/Icatu perf': this.formatValue(perfSeguradora),
                'Valor XP/Icatu total': this.formatValue(admSeguradora + perfSeguradora),
                'Valor Leblon adm': this.formatValue(admLeblon),
                'Valor Leblon perf': this.formatValue(perfLeblon),
                'Valor Leblon Total': this.formatValue(admLeblon + perfLeblon)
            }
        },
        async exportPrev() {
            let prevFund = ['Leblon 70 XP', 'Leblon 100 XP', 'Leblon Icatu Previdencia', 'Leblon 100 Icatu']
            let objToTable = prevFund.reduce((acc, fund) => {
                acc[fund] = this.createDataToPrevFund(fund)
                return acc
            }, {})

            let csvContent = ''
            let alreadyUsedKeyToCreateTable = false
            Object.keys(objToTable).map(key => { // Adicionando headers com os nomes dos fundos
                csvContent = csvContent + ';' + key
            })
            Object.keys(objToTable).map(key => {
                if (!alreadyUsedKeyToCreateTable) {
                    alreadyUsedKeyToCreateTable = true
                    Object.keys(objToTable[key]).map(header => {
                        csvContent = csvContent + '\n' + header + ';'
                        Object.keys(objToTable).map(fund => {
                            let value = objToTable[fund][header]
                            csvContent = csvContent + value + ';'
                        })
                    })
                }
            }) 
            let encodedUri = encodeURI(csvContent)
            let link = document.createElement("a")
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
            link.setAttribute("download", "rebate_prev.csv")
            document.body.appendChild(link)
            link.click()
        },
        changeAllDistributorsToDownloadFileCheckboxes(value) {
            this.downloadFileDistributorsData.forEach(row => {
                row.checkboxStatus = value
            })
        },
        async exportDistribuidoras() {
            this.downloadDistributorDialogVisible = false

            let checkedDistributors = new Set()
            this.downloadFileDistributorsData.map(row => {
                if (row.checkboxStatus == true) {
                    checkedDistributors.add(row.distribuidora)
                }
            })

            let tableDataGroupedByDistribuidoraMellonOuPerformitReversao = {}
            this.tableData.map((row) => {
                if (checkedDistributors.has(row.distribuidoraPerformit)) {
                    let distribuidoraPerformitInRow = row.distribuidoraPerformit
                    if (tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraPerformitInRow] == undefined) {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraPerformitInRow] = [row]
                    } else {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraPerformitInRow].push(row)
                    }
                }
                if (checkedDistributors.has(row.distribuidora) && 
                    (!row.distribuidoraPerformit || !this.distribuidoraEReversao(row.distribuidoraPerformit)) && // Só quero colocar o cliente no arquivo da distribuidora Mellon se não for reversão.
                    (!row.distribuidoraPerformit || !row.distribuidoraPerformit.toUpperCase().includes('SEM REBATE')) // Só quero colocar o cliente no arquivo da distribuidora Mellon se não for sem rebate.
                ) {
                    let distribuidoraMellonInRow = row.distribuidora
                    if (tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraMellonInRow] == undefined) {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraMellonInRow] = [row]
                    } else {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraMellonInRow].push(row)
                    }
                }
            })

            console.log(tableDataGroupedByDistribuidoraMellonOuPerformitReversao)

            let randomToClassName = Math.random()
            Object.keys(tableDataGroupedByDistribuidoraMellonOuPerformitReversao).map(distribuidora => {
                let totalAdm = 0
                let totalPerf = 0
                let totalAdmPorFundo = {}
                let totalPerfPorFundo = {}
                tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].sort((a, b) => {
                    if(a.nomeDoCliente > b.nomeDoCliente) return 1
                    if(a.nomeDoCliente < b.nomeDoCliente) return -1
                    return 0
                })
                tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].sort((a, b) => {
                    if(a.descricaoDoFundo > b.descricaoDoFundo) return 1
                    if(a.descricaoDoFundo < b.descricaoDoFundo) return -1
                    return 0
                })
                let listaDeFundos = [... new Set(tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].map((rowAsObj) => {
                    totalAdmPorFundo[rowAsObj.descricaoDoFundo] = 0
                    totalPerfPorFundo[rowAsObj.descricaoDoFundo] = 0
                    return rowAsObj.descricaoDoFundo
                }))]
                let csvContent = ";;;TX ADM;TX PERF\n"
                    + tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].map((rowAsObj) => {
                        totalAdm += (this.formatedValueToFloat(rowAsObj.valorAcatadoAdm) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoAdm))
                        totalPerf += (this.formatedValueToFloat(rowAsObj.valorAcatadoPerf) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoPerf))
                        totalAdmPorFundo[rowAsObj.descricaoDoFundo] += (this.formatedValueToFloat(rowAsObj.valorAcatadoAdm) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoAdm))
                        totalPerfPorFundo[rowAsObj.descricaoDoFundo] += (this.formatedValueToFloat(rowAsObj.valorAcatadoPerf) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoPerf))
                        let rowAsArray = [
                            distribuidora,
                            rowAsObj.descricaoDoFundo,
                            rowAsObj.nomeDoCliente,
                            rowAsObj.valorAcatadoAdm,
                            rowAsObj.valorAcatadoPerf
                        ]
                        return rowAsArray.join(";")
                    }).join("\n") + "\n\n"
                    + listaDeFundos.map((fundo) => {
                        let rowAsArray = [
                            "",
                            "",
                            fundo,
                            this.formatValue(totalAdmPorFundo[fundo]),
                            this.formatValue(totalPerfPorFundo[fundo])
                        ]
                        console.log(rowAsArray)
                        return rowAsArray.join(";")
                    }).join("\n")
                    + `\n;;TOTAL;${this.formatValue(totalAdm)};${this.formatValue(totalPerf)}`
                console.log({totalAdmPorFundo: totalAdmPorFundo})
                let encodedUri = encodeURI(csvContent)
                let link = document.createElement("a")
                link.setAttribute("class", `linkToDownloadDistribuidora-${randomToClassName}`)
                link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
                link.setAttribute("download", `${distribuidora}.csv`)
                document.body.appendChild(link)
            })
            let links = document.getElementsByClassName(`linkToDownloadDistribuidora-${randomToClassName}`)
            let i = 0
            for (i; i < links.length; i++) {
                links[i].click()
                await sleep(1000)
            }
        },
        showDownloadFileDistributorDialog() {
            this.downloadDistributorDialogVisible = true
        },
        closeDownloadFileDistributorDialog () {
            this.downloadFileDistributorsData.map((row) => row.checkboxStatus = false)
            this.downloadDistributorDialogVisible = false
        },
        showDialogEmailDistributors() {
            db.collection('rebateDistributorsEmailTemplate')
                .get()
                .then(
                    q => {
                        q.forEach(doc => {
                            this.emailTemplate = {
                                recipients: doc.data().recipients,
                                subject: doc.data().subject,
                                content: doc.data().content,
                                firebaseDocId: doc.id
                            }
                        })
                    }
                )
            this.dialogEmailDistributorsVisible = true
        },
        closeEmailToDistributorDialog () {
            this.sendEmailToDistributorsData.map((row) => row.checkboxStatus = false)
            this.emailToDistributorDialogVisible = false
        },
        async updateDistributorsEmailTemplate() {
            let emailTemplate = {
                recipients: this.emailTemplate.recipients,
                subject: this.emailTemplate.subject,
                content: this.emailTemplate.content,
            }            
            try {
                let docId = this.emailTemplate.firebaseDocId
                await db.collection('rebateDistributorsEmailTemplate').doc(docId).update(emailTemplate)
                this.dialogEmailDistributorsVisible = false
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        showEmailToDistributorDialog() {
            this.emailToDistributorDialogVisible = true
        },
        changeAllDistributorsToSendEmailCheckboxes(value) {
            this.sendEmailToDistributorsData.forEach(row => {
                row.checkboxStatus = value
            })
        },
        async sendEmailToDistributorsConfirm() {
            this.$confirm('Você tem certeza que quer mandar emails para as distribuidoras selecionadas?', {
                confirmButtonText: 'Enviar emails',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(async () => {
                this.emailToDistributorDialogVisible = false
                await this.sendEmailToDistributors()
                this.$message({
                    type: 'success',
                    message: 'Emails enviados'
                })
            }).catch((err) => {
                console.log(err)
                this.$message({
                    type: 'info',
                    message: 'Operação cancelada'
                });          
            });
        },
        async sendEmailToDistributors() {
            let checkedDistributors = new Set()
            this.sendEmailToDistributorsData.map(row => {
                if (row.checkboxStatus == true) {
                    checkedDistributors.add(row.distribuidora)
                }
            })

            let tableDataGroupedByDistribuidoraMellonOuPerformitReversao = {}
            this.tableData.map((row) => {
                if (checkedDistributors.has(row.distribuidoraPerformit)) {
                    let distribuidoraPerformitInRow = row.distribuidoraPerformit
                    if (tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraPerformitInRow] == undefined) {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraPerformitInRow] = [row]
                    } else {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraPerformitInRow].push(row)
                    }
                }
                if (checkedDistributors.has(row.distribuidora) && 
                    (!row.distribuidoraPerformit || !this.distribuidoraEReversao(row.distribuidoraPerformit)) && // Só quero colocar o cliente no arquivo da distribuidora Mellon se não for reversão.
                    (!row.distribuidoraPerformit || !row.distribuidoraPerformit.toUpperCase().includes('SEM REBATE')) // Só quero colocar o cliente no arquivo da distribuidora Mellon se não for sem rebate.
                ) { 
                    let distribuidoraMellonInRow = row.distribuidora
                    if (tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraMellonInRow] == undefined) {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraMellonInRow] = [row]
                    } else {
                        tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidoraMellonInRow].push(row)
                    }
                }
            })
            
            console.log(tableDataGroupedByDistribuidoraMellonOuPerformitReversao)

            await Promise.all(Object.keys(tableDataGroupedByDistribuidoraMellonOuPerformitReversao).map(async distribuidora => {
                tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora] = tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].filter(row => {
                    return row.valorAcatadoAdm != 0 || row.valorAcatadoPerf != 0
                })
                let totalAdm = 0
                let totalPerf = 0
                let totalAdmPorFundo = {}
                let totalPerfPorFundo = {}
                tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].sort((a, b) => {
                    if(a.nomeDoCliente > b.nomeDoCliente) return 1
                    if(a.nomeDoCliente < b.nomeDoCliente) return -1
                    return 0
                })
                tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].sort((a, b) => {
                    if(a.descricaoDoFundo > b.descricaoDoFundo) return 1
                    if(a.descricaoDoFundo < b.descricaoDoFundo) return -1
                    return 0
                })
                let distributorsEmails = this.distributorsEmails[distribuidora].email.split(';')
                let listaDeFundos = [... new Set(tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].map((rowAsObj) => {
                    totalAdmPorFundo[rowAsObj.descricaoDoFundo] = 0
                    totalPerfPorFundo[rowAsObj.descricaoDoFundo] = 0
                    return rowAsObj.descricaoDoFundo
                }))]
                let attachmentContent = ";;;TX ADM;TX PERF\n"
                    + tableDataGroupedByDistribuidoraMellonOuPerformitReversao[distribuidora].map((rowAsObj) => {
                        totalAdm += (this.formatedValueToFloat(rowAsObj.valorAcatadoAdm) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoAdm))
                        totalPerf += (this.formatedValueToFloat(rowAsObj.valorAcatadoPerf) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoPerf))
                        totalAdmPorFundo[rowAsObj.descricaoDoFundo] += (this.formatedValueToFloat(rowAsObj.valorAcatadoAdm) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoAdm))
                        totalPerfPorFundo[rowAsObj.descricaoDoFundo] += (this.formatedValueToFloat(rowAsObj.valorAcatadoPerf) === undefined ? 0 : this.formatedValueToFloat(rowAsObj.valorAcatadoPerf))
                        let rowAsArray = [
                            distribuidora,
                            rowAsObj.descricaoDoFundo,
                            rowAsObj.nomeDoCliente,
                            rowAsObj.valorAcatadoAdm,
                            rowAsObj.valorAcatadoPerf
                        ]
                        return rowAsArray.join(";")
                    }).join("\n") + "\n\n"
                    + listaDeFundos.map((fundo) => {
                        let rowAsArray = [
                            "",
                            "",
                            fundo,
                            this.formatValue(totalAdmPorFundo[fundo]),
                            this.formatValue(totalPerfPorFundo[fundo])
                        ]
                        console.log(rowAsArray)
                        return rowAsArray.join(";")
                    }).join("\n")
                    + `\n;;TOTAL;${this.formatValue(totalAdm)};${this.formatValue(totalPerf)}`
                let attachmentName = `${distribuidora}.csv`

                let subject = this.emailTemplate.subject
                let content = this.emailTemplate.content

                let recipients = [
                    ...this.emailTemplate.recipients.split(';'), 
                    ...distributorsEmails
                ]

                let sendRebateDistributorsEmail = firebase.functions().httpsCallable('sendRebateDistributorsEmail')
                let result = await sendRebateDistributorsEmail({
                    recipients, subject, content, attachment: { attachmentName, attachmentContent }
                })
            }))
        },
        exportIcatu() {
            // TODO Implementar
        },
        generateStringMellon(fundo, favorecido, cnpj, tableDataConsolidada, headerName, value) {
            let dateObj = new Date()
            let currentDay = dateObj.getDate().toString().length == 1 ? `0${dateObj.getDate()}` : dateObj.getDate()
            let currentMonth = (dateObj.getMonth() + 1).toString().length == 1 ? `0${dateObj.getMonth() + 1}` : dateObj.getMonth() + 1
            let currentYear = dateObj.getFullYear()
            let formateddateObj = `${currentYear}${currentMonth}${currentDay}`

            let fundoNaoDeveAparecerNaBoletagemFlag = false
            this.fundosNaoDevemAparecerNaBoletagem.map(fundoObj => {
                if (fundoObj.nome.includes(fundo)) {
                    fundoNaoDeveAparecerNaBoletagemFlag = true
                }
            })
            if (value == 0 || fundoNaoDeveAparecerNaBoletagemFlag) {
                return ''
            }
            return `${formateddateObj};${fundo};${headerName};${this.formatValue(value)};${cnpj};${favorecido};`
                + `${currentMonth};${currentYear};;${cnpj}\n`
        },
        valorDeveriaIrParaGestor(favorecido, nomeDoFundo, nomeDoCliente) {
            let clienteESemRebate = favorecido.toUpperCase().includes('SEM REBATE')
            let distribuidorEMellon = favorecido.includes('BNY MELLON')
            let gestorEDistribuidorExcetoParaXPEIcatu = favorecido == gestorName && 
                !([FUNDO_70_XP, FUNDO_100_XP, FUNDO_100_ICATU].includes(nomeDoFundo))
            
            let clienteNaoTemContrato = false
            // Preciso fazer dessa forma porque no caso de conta e ordem o nome do cliente não bate certinho
            this.fundosSemContrato.map((fundoSemContrato) => {
                if (nomeDoCliente.includes(fundoSemContrato)) {
                    clienteNaoTemContrato = true
                }
            })

            return clienteESemRebate || distribuidorEMellon || gestorEDistribuidorExcetoParaXPEIcatu || clienteNaoTemContrato
        },
        exportMellon() {
            let csvContent = ''
            let tableDataConsolidada = {}
            let gestorAdmAndPerfByFundo = {}
            gestorAdmAndPerfByFundo[gestorName] = {}

            this.tableData.map((row) => {
                // Criar objeto do fundo no objeto de gestor, se não existir
                if (!gestorAdmAndPerfByFundo[gestorName][row.descricaoDoFundo]) {
                    gestorAdmAndPerfByFundo[gestorName][row.descricaoDoFundo] = {
                        adm: 0,
                        perf: 0
                    }
                }

                // Verificar se o cliente é por reversão e se for deixar separado da distribuidora
                let favorecido
                let cnpjFavorecido = ''
                let reversaoBoolean
                let maybeReversaoClienteInLista = this.listaReversao.filter(clienteReversao => row.nomeDoCliente == this.fixTyposInClientName(clienteReversao.nome))
                if (maybeReversaoClienteInLista.length > 0) {
                    favorecido = row.nomeDoCliente
                    cnpjFavorecido = maybeReversaoClienteInLista[0].cnpj
                    reversaoBoolean = true
                } else if (row.nomeDoCliente == 'FUNDO DE INVESTIMENTO CAIXA PENHA ACOES' || row.nomeDoCliente == 'FIC DE FI CAIXA RIO DOURO ACOES') {
                    // Os valores desses fundos devem ir pra Genial. Colocando a regra direto no código pois não pensamos em
                    // uma forma melhor (usando uma interface).
                    favorecido = 'GENIAL INVESTIMENTOS CVM SA'
                    this.listaDistribuidoras.map((distribuidora) => {
                        if (distribuidora.nome == favorecido) {
                            cnpjFavorecido = distribuidora.cnpj
                        }
                    })
                    reversaoBoolean = false
                } else if (row.distribuidoraPerformit && row.distribuidoraPerformit.toUpperCase().includes('SEM REBATE')) {
                    // Fundos sem rebate o valor deve ir para o gestor. Colocar distribuidora performit como favorecido e na lógica de
                    // verificar se o valor deve ir pro gestor incluir checar se o favorecido contém "SEM REBATE".
                    favorecido = row.distribuidoraPerformit
                    reversaoBoolean = false
                } else {
                    this.listaDistribuidoras.map((distribuidora) => {
                        if (distribuidora.nome == row.distribuidora) {
                            cnpjFavorecido = distribuidora.cnpj
                        }
                    })
                    favorecido = row.distribuidora
                    reversaoBoolean = false
                }

                // Só criar uma linha para o cliente se o valor não dever ir para o gestor (linha do gestor para o fundo)
                if (!this.valorDeveriaIrParaGestor(favorecido, row.descricaoDoFundo, row.nomeDoCliente)) {
                    if (!tableDataConsolidada[favorecido]) {
                        tableDataConsolidada[favorecido] = {}
                    }
                    if (!tableDataConsolidada[favorecido][row.descricaoDoFundo]) {
                        tableDataConsolidada[favorecido][row.descricaoDoFundo] = {
                            admDist: 0,
                            perfDist: 0,
                            reversao: reversaoBoolean,
                            cnpjFavorecido
                        }
                    }
                }

                let valorAcatadoAdmTratado = this.formatedValueToFloat(row.valorAcatadoAdm) == undefined ? 0 : this.formatedValueToFloat(row.valorAcatadoAdm)
                let valorAcatadoPerfTratado = this.formatedValueToFloat(row.valorAcatadoPerf) == undefined ? 0 : this.formatedValueToFloat(row.valorAcatadoPerf)

                if (!this.valorDeveriaIrParaGestor(favorecido, row.descricaoDoFundo, row.nomeDoCliente)) {
                    tableDataConsolidada[favorecido][row.descricaoDoFundo].admDist += valorAcatadoAdmTratado
                    tableDataConsolidada[favorecido][row.descricaoDoFundo].perfDist += valorAcatadoPerfTratado
                } else {
                    gestorAdmAndPerfByFundo[gestorName][row.descricaoDoFundo].adm += valorAcatadoAdmTratado
                    gestorAdmAndPerfByFundo[gestorName][row.descricaoDoFundo].perf += valorAcatadoPerfTratado
                }

                let percMellonObjToCurrentFund = this.pagamentoServicoFileData.filter((pagamentoServicoFileDataRow) => pagamentoServicoFileDataRow.fundo == row.descricaoDoFundo)
                let percMellonToCurrentFund = 0
                if (percMellonObjToCurrentFund.length == 0) {
                    console.log(`Não foi encontrado o percentual Mellon para o fundo: ${row.descricaoDoFundo}`)
                    this.$root.$emit('showError', `Não foi encontrado o percentual Mellon para o fundo: ${row.descricaoDoFundo}`, 'error')
                } else {
                    percMellonToCurrentFund = percMellonObjToCurrentFund[0].percMellon
                }

                let admGestor = (row.taxaDeAdministracao - valorAcatadoAdmTratado - (row.taxaDeAdministracao * percMellonToCurrentFund))
                gestorAdmAndPerfByFundo[gestorName][row.descricaoDoFundo].adm += admGestor

                let dateObj = new Date()
                let currentMonth = dateObj.getMonth() + 1
                let taxaDePerformance = currentMonth == 6 || currentMonth == 12
                    ? row.taxaDePerformanceSobreResgate + row.taxaDePerformanceApropriada
                    : row.taxaDePerformanceSobreResgate
                let perfGestor = (taxaDePerformance - valorAcatadoPerfTratado)
                gestorAdmAndPerfByFundo[gestorName][row.descricaoDoFundo].perf += perfGestor
            })

            // Linhas respectivas ao favorecido do cliente
            Object.keys(tableDataConsolidada).map((favorecido) => {
                Object.keys(tableDataConsolidada[favorecido]).map((fundo) => {
                    if (fundo == FUNDO_70_XP || fundo == FUNDO_100_XP) {
                        csvContent += this.generateStringMellon(fundo, xpName, xpCNPJ, tableDataConsolidada, 'Taxa de Administração - Gestor', tableDataConsolidada[favorecido][fundo].admDist)
                        csvContent += this.generateStringMellon(fundo, xpName, xpCNPJ, tableDataConsolidada, 'Taxa de Performance - Gestor', tableDataConsolidada[favorecido][fundo].perfDist)
                    } else if (fundo == FUNDO_100_ICATU) {
                        csvContent += this.generateStringMellon(fundo, icatuName, icatuCNPJ, tableDataConsolidada, 'Taxa de Administração - Consultor', tableDataConsolidada[favorecido][fundo].admDist)
                        csvContent += this.generateStringMellon(fundo, icatuName, icatuCNPJ, tableDataConsolidada, 'Taxa de Performance - Consultor', tableDataConsolidada[favorecido][fundo].perfDist)
                    } else if (tableDataConsolidada[favorecido][fundo].reversao) {
                        csvContent += this.generateStringMellon(fundo, favorecido, tableDataConsolidada[favorecido][fundo].cnpjFavorecido, tableDataConsolidada, 'Taxa de Administração - Reversão direta', tableDataConsolidada[favorecido][fundo].admDist)
                        csvContent += this.generateStringMellon(fundo, favorecido, tableDataConsolidada[favorecido][fundo].cnpjFavorecido, tableDataConsolidada, 'Taxa de Performance - Reversão direta', tableDataConsolidada[favorecido][fundo].perfDist)
                    } else {
                        csvContent += this.generateStringMellon(fundo, favorecido, tableDataConsolidada[favorecido][fundo].cnpjFavorecido, tableDataConsolidada, 'Taxa de Administração - Distribuidor', tableDataConsolidada[favorecido][fundo].admDist)
                        csvContent += this.generateStringMellon(fundo, favorecido, tableDataConsolidada[favorecido][fundo].cnpjFavorecido, tableDataConsolidada, 'Taxa de Performance - Distribuidor', tableDataConsolidada[favorecido][fundo].perfDist)
                    }
                })
            })

            // Linhas respectivas à Leblon como gestora
            Object.keys(gestorAdmAndPerfByFundo[gestorName]).map((fundo) => {
                csvContent += this.generateStringMellon(fundo, gestorName, gestorCNPJ, gestorAdmAndPerfByFundo, 'Taxa de Administração - Gestor', gestorAdmAndPerfByFundo[gestorName][fundo].adm)
                csvContent += this.generateStringMellon(fundo, gestorName, gestorCNPJ, gestorAdmAndPerfByFundo, 'Taxa de Performance - Gestor', gestorAdmAndPerfByFundo[gestorName][fundo].perf)
            })
 
            let encodedUri = encodeURI(csvContent)
            let link = document.createElement("a")
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodedUri)
            link.setAttribute("download", "mellon_boletagem.csv")
            document.body.appendChild(link)
            link.click()
        },
        showEditReversaoDialog() {
            this.listaReversaoDialogVisible = true
        },
        async addReversao() {
            this.listaReversao.push({...this.newReversao})
            await db.collection('rebateExcecoesCadastro').doc('listaReversao').set({
                data: this.listaReversao
            })
            this.newReversao = {
                nome: '',
                cnpj: ''
            }
        },
        async editReversao(value, scope) {
            await db.collection('rebateExcecoesCadastro').doc('listaReversao').set({
                data: this.listaReversao
            })
        },
        async removerReversao(scope) {
            this.listaReversao = this.listaReversao.filter((reversaoCase) => reversaoCase.nome != scope.row.nome)
            await db.collection('rebateExcecoesCadastro').doc('listaReversao').set({
                data: this.listaReversao
            })
        },
        closeEditReversaoDialog() {
            this.newReversao = {
                nome: '',
                cnpj: ''
            }
            this.listaReversaoDialogVisible = false
        },
        showEditFundosSemContratoDialog() {
            this.fundosSemContratoDialogVisible = true
        },
        async addFundoSemContrato() {
            this.fundosSemContrato.push({...this.newFundoSemContrato})
            await db.collection('rebateExcecoesCadastro').doc('fundosSemContrato').set({
                data: this.fundosSemContrato
            })
            this.newFundoSemContrato = {
                nome: ''
            }
        },
        async editFundosSemContrato() {
            await db.collection('rebateExcecoesCadastro').doc('fundosSemContrato').set({
                data: this.fundosSemContrato
            })
        },
        async removerFundosSemContrato(scope) {
            this.fundosSemContrato = this.fundosSemContrato.filter((fundoSemContrato) => fundoSemContrato.nome != scope.row.nome)
            await db.collection('rebateExcecoesCadastro').doc('fundosSemContrato').set({
                data: this.fundosSemContrato
            })
        },
        closeEditFundosSemContratoDialog() {
            this.newFundoSemContrato = {
                nome: ''
            }
            this.fundosSemContratoDialogVisible = false
        },
        showEditFundosNaoDevemAparecerNaBoletagemDialog() {
            this.fundosNaoDevemAparecerNaBoletagemDialogVisible = true
        },
        async addFundosNaoDevemAparecerNaBoletagem() {
            this.fundosNaoDevemAparecerNaBoletagem.push({...this.newFundoNaoDevemAparecerNaBoletagem})
            await db.collection('rebateExcecoesCadastro').doc('fundosNaoDevemAparecerNaBoletagem').set({
                data: this.fundosNaoDevemAparecerNaBoletagem
            })
            this.newFundoNaoDevemAparecerNaBoletagem = {
                nome: ''
            }
        },
        async editFundosNaoDevemAparecerNaBoletagem() {
            await db.collection('rebateExcecoesCadastro').doc('fundosNaoDevemAparecerNaBoletagem').set({
                data: this.fundosNaoDevemAparecerNaBoletagem
            })
        },
        async removerFundosNaoDevemAparecerNaBoletagem(scope) {
            this.fundosNaoDevemAparecerNaBoletagem = this.fundosNaoDevemAparecerNaBoletagem.filter(
                (fundoNaoDevemAparecerNaBoletagem) => fundoNaoDevemAparecerNaBoletagem.nome != scope.row.nome)
            await db.collection('rebateExcecoesCadastro').doc('fundosNaoDevemAparecerNaBoletagem').set({
                data: this.fundosNaoDevemAparecerNaBoletagem
            })
        },
        closeEditFundosNaoDevemAparecerNaBoletagemDialog() {
            this.newFundoNaoDevemAparecerNaBoletagem = {
                nome: ''
            }
            this.fundosNaoDevemAparecerNaBoletagemDialogVisible = false
        },
        showEditDistribuidoraDialog() {
            this.listaDistribuidorasDialogVisible = true
        },
        async addDistribuidora() {
            this.listaDistribuidoras.push({...this.newDistribuidora})
            await db.collection('rebateExcecoesCadastro').doc('listaDistribuidoras').set({
                data: this.listaDistribuidoras
            })
            this.newDistribuidora = {
                nome: '',
                cnpj: ''
            }
        },
        async editDistribuidora(value, scope) {
            await db.collection('rebateExcecoesCadastro').doc('listaDistribuidoras').set({
                data: this.listaDistribuidoras
            })
        },
        async removerDistribuidora(scope) {
            this.listaDistribuidoras = this.listaDistribuidoras.filter((distribuidora) => distribuidora.nome != scope.row.nome)
            await db.collection('rebateExcecoesCadastro').doc('listaDistribuidoras').set({
                data: this.listaDistribuidoras
            })
        },
        closeEditDistribuidoraDialog() {
            this.newDistribuidora = {
                nome: '',
                cnpj: ''
            }
            this.listaDistribuidorasDialogVisible = false
        }
    },
    computed: {
        filteredTableData() {
            this.tablePage = 1
            
            return this.tableData.filter((row) => {
                let shouldShowRow = true
                Object.keys(this.currentFilters).map((columnToFilter) => {
                    if (this.currentFilters[columnToFilter].length > 0 && !this.currentFilters[columnToFilter].includes(row[columnToFilter])) {
                        shouldShowRow = false
                    }
                })
                return shouldShowRow
            })
        },
        displayData() {
            if (!this.filteredTableData || this.filteredTableData.length === 0) return []
            let startLine = this.linesInTablePage * (this.tablePage - 1)
            let endLine = this.linesInTablePage * (this.tablePage) 
            return this.filteredTableData.slice(startLine, endLine)
        },
        totalLinesInTable() {
            return this.filteredTableData.length
        },
        heightClientsTable() {
            return window.innerHeight * 0.8
        },
        distribuidoraFilters() {
            return this.getFilterPossibleValues('distribuidora')
        },
        distribuidoraPerformitFilters() {
            return this.getFilterPossibleValues('distribuidoraPerformit')
        },
        descricaoDoFundoFilters() {
            return this.getFilterPossibleValues('descricaoDoFundo')
        }
    },
    async created() {
        db.collection('rebateDistributorsEmailTemplate')
            .onSnapshot(
                q => {
                    q.forEach(doc => {
                        this.emailTemplate = {
                            subject: doc.data().subject,
                            recipients: doc.data().recipients,
                            content: doc.data().content,
                            firebaseDocId: doc.id
                        }
                    })
                }
            )

        let docFundosNaoDevemAparecerNaBoletagem = await db.collection('rebateExcecoesCadastro').doc('fundosNaoDevemAparecerNaBoletagem').get()
        this.fundosNaoDevemAparecerNaBoletagem = docFundosNaoDevemAparecerNaBoletagem.data().data

        let docFundosSemContrato = await db.collection('rebateExcecoesCadastro').doc('fundosSemContrato').get()
        this.fundosSemContrato = docFundosSemContrato.data().data

        let docListaReversao = await db.collection('rebateExcecoesCadastro').doc('listaReversao').get()
        this.listaReversao = docListaReversao.data().data

        let docListaDistribuidoras = await db.collection('rebateExcecoesCadastro').doc('listaDistribuidoras').get()
        this.listaDistribuidoras = docListaDistribuidoras.data().data

        let rules = await db.collection('rebateRegrasCadastro').get()
        rules.forEach(doc => {
            this.optionsDistributorPerformit.push({
                value: doc.data().distribuidora,
                label: doc.data().distribuidora
            })
            this.rules[doc.data().distribuidora] = {
                ativo: doc.data().ativo,
                percAdm: doc.data().percAdm,
                percPerf: doc.data().percPerf,
                liquidoBruto: doc.data().liquidoBruto,
                data: doc.data().data,
                observacoes: doc.data().observacoes,
                emails: doc.data().emails
            }
        })
        this.optionsDistributorPerformit.sort((op1, op2) => {
            if (op1.label < op2.label) {
                return -1
            } else {
                return 1
            }
        })

        await this.updateDistributorsEmailsObject()
    },
}
</script>

<style>
.el-table .warning-row {
    background: rgb(255, 204, 189);
}
.el-table .success-row {
    background: #d0ffb6;
}
.el-table .not-found-row {
    background: #cfcece;
}
</style>

<style scoped>
.distributor {
    width: 1500px;
}
.el-dialog .main-title {
    font-weight: bold;
    font-size: 22px;
}
.el-dialog .title-detail {
    font-style: italic;
    font-size: 18px;
}
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
    height: 23px;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 5px;
}
.header-manual {
    font-family: Calibri;
    color: #606266;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.header-details {
    text-align: center;
}
.el-table .cell {
    word-wrap: break-word;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.upload-element {
    margin-top: 20px;
    margin-bottom: 20px;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
#table-div {
    position: relative;
    margin-top: 10px;
    margin-right: 20px;
}
#pagination {
    text-align: center; 
    margin: 10px;
}
</style>